import {
  FormControlLabel,
  GKButton,
  GKEditor,
  GKModal,
  Grid2,
  InfolconIcon,
  Switch,
  Typography,
} from "components";
import { useMutation } from "hooks/useQueries";
import { Controller, useFormContext } from "react-hook-form";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import OrderSheetGeneratePopover from "./OrderSheetGeneratePopover";
import { ModelPortfolio } from "interfaces/OrderSimulation";

const GenerateOrderSheetModal = (
  props: GKModalProps & {
    modelId: number;
    modelPortfolioList: ModelPortfolio[];
  },
) => {
  const { open, setOpen, modelId, modelPortfolioList } = props;

  const form = useFormContext();

  const { mutate, isLoading } = useMutation({
    mutationKey: ["GENERATE_ORDER_SHEET"],
    mutationFn: (data) =>
      axiosInstance.post(`/model_portfolio/${modelId}/order-manager/`, data),
    onSuccess: () => setOpen(false),
  });

  return (
    <GKModal
      modalTitle={"Generate Order Sheet"}
      open={open}
      setOpen={setOpen}
      maxHeight="550px"
      width={"656px"}
    >
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Controller
            control={form.control}
            name="generateOrderSheet.rationale"
            render={({ field }) => {
              return (
                <GKEditor
                  {...field}
                  inputLabel="Rationale"
                  toolbar={[
                    "undo",
                    "redo",
                    "|",
                    "heading",
                    "bold",
                    "italic",
                    "underline",
                    "strikethrough",
                    "blockQuote",
                    "insertTable",
                    "tableColumn",
                    "tableRow",
                    "mergeTableCells",
                    "tableToolbar",
                  ]}
                />
              );
            }}
          />
        </Grid2>
        <Grid2 container size={12} alignItems={"center"}>
          <Grid2 size={6}>
            <Controller
              control={form.control}
              name="generateOrderSheet.limitOrder"
              render={({ field }) => {
                return (
                  <FormControlLabel
                    control={<Switch {...field} />}
                    label="Generate order using limit value"
                  />
                );
              }}
            />
          </Grid2>
          <Grid2
            size={6}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"flex-end"}
            gap={1}
          >
            <GKButton
              variant="outlined"
              color="dark"
              loading={isLoading}
              onClick={() => {
                const isRebalanceByCompany =
                  form.getValues("allocation")?.allocType === "rebalance" &&
                  form.getValues("allocation")?.allocationBy === "company";

                mutate({
                  ...form.getValues("allocation"),
                  ...form.getValues("generateOrderSheet"),
                  stockWise: !!isRebalanceByCompany,
                  useCurrentAllocation:
                    form.getValues("allocation")?.useCurrentAllocation ===
                    "current",
                  allocationBy: isRebalanceByCompany
                    ? "version"
                    : form.getValues("allocation.allocationBy"),
                });
              }}
            >
              Save as Draft
            </GKButton>
            <OrderSheetGeneratePopover
              modelPortfolioList={modelPortfolioList}
              modelId={modelId}
            />
          </Grid2>
        </Grid2>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
          <InfolconIcon color=" #9AA4B2" />
          <Typography fontSize={12} fontWeight={600} color=" #697586">
            You’ll find this draft saved under your Order Management for future
            actions.
          </Typography>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default GenerateOrderSheetModal;
